import React from "react";
import styles from './PlaceImagesSquare.module.scss';
import {IProduct} from 'data/interfaces/products';
import {config} from 'data/utils/constants';
import {SizeMe} from "react-sizeme";
import Gallery from "./components/gallery/Gallery";
import {generateAssetList} from "../../utils";
import {getPlaceDetailsName} from "data/redux/selectors/productSelector";


export interface IPlaceImagesSquareProps {
  product: IProduct;
  className?: string;
  showIcon?: boolean;
  children?: any;
}

const PlaceImagesSquare = (props: IPlaceImagesSquareProps) => (
  <SizeMe>{({size: {width}}) => {
    const isMobile = width <= 680;
    return (
      <Gallery
        images={generateAssetList(props.product)
          .map(({asset: {sourceLink, local}}) => ({
            fullscreen: local ? sourceLink : `${config.api_server.placeImageUrl}/placephoto/${sourceLink}?maxwidth=${1920}`,
            original: local ? sourceLink : `${config.api_server.placeImageUrl}/placephoto/${sourceLink}?maxwidth=${802}`,
            thumbnail: local ? sourceLink : `${config.api_server.placeImageUrl}/placephoto/${sourceLink}?maxwidth=${85}`,
            originalAlt: getPlaceDetailsName(props.product),
            thumbnailAlt: getPlaceDetailsName(props.product),
          }))}
        galleryOverrides={{
          additionalClass: `${styles.PlaceImagesSquare} ${isMobile ? styles.mobile : ''}`.trim()
        }}
        overlayClassName={props.className}
        overlay={props.children}
        width={width}

      />);
  }
  }</SizeMe>
);

PlaceImagesSquare.defaultProps = {
  showIcon: true,
  style: {},
};

export default PlaceImagesSquare;
